import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { setGlobalContextProperty } from '@carboncopyco/logger';
import { settings } from '../../../../settings';

export enum LogrocketWindowType {
  DESKTOP_APP = 'DesktopApp',
  SPEAKER_PANEL = 'SpeakerPanel',
  LOGIN_SCREEN = 'LoginScreen',
}

const setUpUser = (windowType: LogrocketWindowType, userData?: any) => {
  if (windowType === LogrocketWindowType.LOGIN_SCREEN) {
    LogRocket.identify({ name: 'anonymous' });
  } else {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { id, name, email, default_organization } = userData || {};
    LogRocket.identify(`${id}_${windowType}`, {
      name,
      email,
      default_organization,
      windowType,
    });
  }
};
const initLogRocket = (
  windowType: LogrocketWindowType = LogrocketWindowType.DESKTOP_APP,
  userData?: any
) => {
  const id = settings.LOGROCKET_APP_ID;
  if (id) {
    LogRocket.init(id, {
      mergeIframes: true,
      childDomains: ['*'],
      console: {
        shouldAggregateConsoleErrors: true,
        isEnabled: true,
      },
      network: {
        isEnabled: true,
      },
      dom: {
        isEnabled: true,
      },
      shouldDebugLog: true,
      shouldParseXHRBlob: true,
    });
    setupLogRocketReact(LogRocket);
    setUpUser(windowType, userData);
    LogRocket.getSessionURL((sessionURL) => {
      window.logRocketSessionURL = sessionURL;
      // add logrocket sessionURL to global context in main process and renderer process
      window.dsDesktop.app.setLogRocketLink(sessionURL);
      setGlobalContextProperty('logRocketSessionURL', sessionURL);
    });
  }
};

export { LogRocket, initLogRocket };
